<template>
<!-- 취소자리스트 팝업 -->
<div class="modal fade" id="student_cancle" tabindex="-1" role="dialog" aria-labelledby="commentLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div>
                    <p class="bold dp-inblock h-30px font-23">{{programName}} <br> 수강신청 취소자 리스트</p>
                    <a class="pointer float-right layer-close ml-30" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                        <img src="../../assets/img/close.png" alt="close" class="close-btn">
                    </a>
                    <p class="font-13 pt-10">
                        - 수강취소자 리스트를 확인 할 수 있습니다.
                    </p>

                    <div class="mt-30">
                        <select v-model="payStatus" @change="changePayStatus()" name="" id="" class="w-130px">
                            <option value="">결제상태 전체</option>
                            <option value="Y">결제완료</option>
                            <option value="N">미결제</option>
                            <option value="X">결제 없음</option>
                            <option value="P">결제 취소 대기</option>
                            <option value="C">결제 취소</option>
                        </select>
                        <button class="admin-btn-default float-right" @click="exportExcel()">엑셀다운로드</button>
                        <table class="admin-table-col mt-10">
                            <colgroup>
                                <col width="50px">
                                <col width="80px">
                                <col width="200px" style="width: 220px">
                                <col width="*" style="width: 110px">
                                <col width="*" style="width: 120px">
                                <col width="100px">
                                <col width="80px">
                                <col width="80px">
                                <col width="80px">
                                <col width="80px">
                                <col width="100px" style="width: 100%">
                                <col width="50px" style="width: 70px">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>No</th>
                                    <th>이름</th>
                                    <th>E-mail</th>
                                    <th>프로그램명</th>
                                    <th>신청과정</th>
                                    <th>취소 신청 일자</th>
                                    <th>취소 상태</th>
                                    <th>결제 방법</th>
                                    <th>카드사 명</th>
                                    <th>결제 여부</th>
                                    <th>결제 금액</th>
                                    <th>신청 복구</th>
                                </tr>
                            </thead>
                            <tbody class="txt-center">
                                <tr v-for="(item, index) of cancleUserList" :key="index" :value="item">
                                    <td>{{listLength - index}}</td>
                                    <td>{{item.name}}</td>
                                    <td class="txt-left">{{item.email}}</td>
                                    <td>{{item.program_name}}</td>
                                    <td class="txt-left">
                                        {{item.subject_name}} <br>
                                        {{item.subject_start_time}} ~ {{item.subject_end_time}}
                                    </td>
                                    <td>{{item.update_date.slice(0, 10)}}</td>
                                    <td><span v-if="item.cancle_status === 'P'">관리자삭제</span>
                                        <span v-else>신청자취소</span></td>
                                    <td>{{formatPayWay(item.pay_way)}}</td>
                                    <td>{{item.cancle_card_name || '-'}}</td>
                                    <td>{{formatPayStatus(item.pay_status)}}</td>
                                    <td>{{item.price || '-'}} 원</td>
                                    <td class="txt-blue pointer" @click="restore(item.email, item.idx)">신청복구</td>
                                    <!-- <td class="pointer txt-blue break-all">복구</td> -->
                                </tr>
                                <tr v-if="listLength === 0">
                                    <td colspan="13" class="pt-10 pb-10">등록된 정보가 없습니다.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer txt-center">
                <a class="pointer admin-btn-default btn ml-05" @click="$emit('close')" data-dismiss="modal" aria-label="Close">확인</a>
            </div>
            <!-- <load-modal v-if="isLoadModalOpened" :parentIdx="parentIdx" @applyProgram="applyProgram" @close="closeModal"></load-modal> -->
        </div>
    </div>
</div>
</template>

<script>
import FileSaver from 'file-saver'
import LoadModal from '@/components/reg/enroll/loadModal.vue'
import {
    GetUrlParams
} from '@/utils/common.js'
export default {
    components: {
        LoadModal,
    },
    props: ['parentIdx'],
    data: () => ({
        status: 'none',

        payStatus: '', // 결제전체 '', 결제완료 'Y',미결제: 'N',결제취소 'C',결제취소대기 'P'
        programIdx: '', // 프로그램 고유 idx

        cancleUserList: [], // 수강신청 취소자 리스트
        listLength: 0, // 수강신청 취소자 인원수

        programName: '',

        parentIdx: '',
        isLoadModalOpened: false, // 프로그램 선택 모달 (불러오기 시)
    }),

    beforeDestroy() {

    },

    mounted() {
        if (sessionStorage.getItem('programName')) {
            this.programName = sessionStorage.getItem('programName')
        }

        console.log('this.parentIdx', this.parentIdx)

        this.parentIdx = this.parentIdx

        // this.isLoadModalOpened = true
        
        var params = {
                payStatus: this.payStatus,
                pageIdx: this.parentIdx
            }

            this.axios.get(this.axios.root + this.axios.port + '/admin/user-cancle', {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.cancleUserList = res.data.cancleUserList
                    this.listLength = this.cancleUserList.length
                } else if (res.data.err === 105) {
                    this.cancleUserList = []
                    this.listLength = 0
                    // alert(res.data.result)
                } else {
                    // alert(res.data.result)
                }
                this.isLoadModalOpened = false
            })
    },

    methods: {
        // 결제방법에 따른 한글 변환
        formatPayWay(status) {
            switch (status) {
                case 'C':
                    return '카드'
                case 'A':
                    return '계좌이체'
                default:
                    return '-'
            }
        },

        // 신청자 복구
        restore(email, studentSubjectIdx) {
            var con_test = confirm("신청완료로 상태를 변경하시겠습니까?");
            if (con_test == true) {
                var params = {
                    email: email,
                    studentSubjectIdx: studentSubjectIdx
                }

                var params = new URLSearchParams()

                params.append('email', email)
                params.append('studentSubjectIdx', studentSubjectIdx)

                this.axios.put(this.axios.root + this.axios.port + '/admin/user-restore', params).then(res => {
                    console.log('res', res)
                    if (res.data.err === 0) {
                        alert('해당 학습자의 취소신청상태가 복구 되었습니다.')
                        this.fetchList()
                    } else if (res.data.err === 105) {

                        // alert(res.data.result)
                    } else {
                        // alert(res.data.result)
                    }
                })
            } else {
                return false
            }
        },

        fetchList () {
            var params = {
                payStatus: this.payStatus,
                pageIdx: this.parentIdx
            }

            this.axios.get(this.axios.root + this.axios.port + '/admin/user-cancle', {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.cancleUserList = res.data.cancleUserList
                    this.listLength = this.cancleUserList.length
                } else if (res.data.err === 105) {
                    this.cancleUserList = []
                    this.listLength = 0
                    // alert(res.data.result)
                } else {
                    // alert(res.data.result)
                }
            })
        },

        // 결제상태 변경시 api 재 호출 함수
        changePayStatus() {
            this.fetchCancleList()
        },

        closeModal() {
            this.isLoadModalOpened = false
        },

        applyProgram(idx) {
            this.programIdx = idx
            var params = {
                programIdx: idx
            }

            var params = {
                payStatus: this.payStatus,
                pageIdx: this.parentIdx
            }

            this.axios.get(this.axios.root + this.axios.port + '/admin/user-cancle', {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.cancleUserList = res.data.cancleUserList
                    this.listLength = this.cancleUserList.length
                } else if (res.data.err === 105) {
                    this.cancleUserList = []
                    this.listLength = 0
                    // alert(res.data.result)
                } else {
                    // alert(res.data.result)
                }
                this.isLoadModalOpened = false
            })
        },

        // 수강신청 취소자 리스트 api 호출 함수
        fetchCancleList() {
            var params = {
                payStatus: this.payStatus,
                pageIdx: this.parentIdx
            }

            this.axios.get(this.axios.root + this.axios.port + '/admin/user-cancle', {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.cancleUserList = res.data.cancleUserList
                    this.listLength = this.cancleUserList.length
                } else if (res.data.err === 105) {
                    this.cancleUserList = []
                    this.listLength = 0
                } else {
                    alert(res.data.result)
                }
            })
        },

        // payStatus에 따른 한글 변환
        formatPayStatus(status) {
            switch (status) {
                case 'Y':
                    return '결제완료'
                case 'N':
                    return '미결제'
                case 'X':
                    return '결제없음'
                case 'C':
                    return '결제취소'
                case 'P':
                    return '결제취소대기'
                default:
                    return '-'
            }
        },

        // 엑셀 다운로드 api 호출
        exportExcel() {
            // 리스트가 0개 미만일때는 다운로드 취소 처리
            if (this.listLength === 0) {
                alert('리스트가 0개인 경우에는 다운로드가 불가능합니다.')
                return false
            }

            var pageIdx = this.parentIdx

            // var params = {
            //     payStatus: this.payStatus,
            //     pageIdx: pageIdx
            // }

            var params = new URLSearchParams()

            params.append('pageIdx', pageIdx)
            params.append('payStatus', this.payStatus)

            this.axios.post(this.axios.root + this.axios.port + `/excel/sugang-cancle-list/${pageIdx}`, params, {
                    responseType: 'arraybuffer'
                })
                .then(res => {
                    console.log('res', res)
                    FileSaver.saveAs(new Blob([res.data]), "sugang_cancle_list.xlsx")

                }).catch(err => {
                    console.log(err)
                    alert(err)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
// .modal {
//     &.modal-overlay {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         position: fixed;
//         z-index: 30;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 100%;
//         background: rgba(0, 0, 0, 0.5);
//     }

//     &-window {
//         background: #fff;
//         border-radius: 4px;
//         overflow: hidden;
//     }

//     &-content {
//         padding: 10px 20px;
//     }

//     &-footer {
//         background: #ccc;
//         padding: 10px;
//         text-align: right;
//     }
// }

// .modal-enter-active,
// .modal-leave-active {
//     transition: opacity 0.4s;

//     .modal-window {
//         transition: opacity 0.4s, transform 0.4s;
//     }
// }

// .modal-leave-active {
//     transition: opacity 0.6s ease 0.4s;
// }

// .modal-enter,
// .modal-leave-to {
//     opacity: 0;

//     .modal-window {
//         opacity: 0;
//         transform: translateY(-20px);
//     }
// }
</style>
